import React, { useContext } from 'react';
import { AnalyticsContextProps } from './interfaces';

export interface AnalyticsContextProviderProps {
    value: AnalyticsContextProps;
    children: React.ReactNode;
}

const context = React.createContext<AnalyticsContextProviderProps | null>(null);

export const AnalyticsContextProvider = ({
    value,
    children,
}: AnalyticsContextProviderProps) => {
    const parentContextValue = useContext(context);
    const mergedValue = parentContextValue ? { ...parentContextValue.value, ...value } : value;
    return <context.Provider value={{ value: mergedValue, children }}>{children}</context.Provider>;
};

export function useAnalyticsContext() {
    const contextValue = useContext(context);
    if (!contextValue) {
        return { context: null };
    }
    const { value } = contextValue;
    return { context: value };
}
